/**
 * @author：
 * @update：
 * @description：
 **/
import {evaluateGet,evaluateDetails,evaluateDelete} from '@/api/evaluate'
import download from "downloadjs";
import {fileEcho} from "@/api/url";
import CusPagination from "@/components/cusPagination";

export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            evaluateLoad:false,//loading
            searchForm: {
                orderNo: '',
                unionId:'',
                username:'',
                type:'',
                createdDate:'',
                state:''
            },//搜索from
            tableData: [],
            tableDataLoc:fileEcho,
            currentPage: 1,
            pageSize: 10,
            total:0,
        };
    },
    // 自定义方法
    methods: {
        //搜索
        seachBtn() {
            this.getList();
        },
        //重置
        resetBtn() {
            this.searchForm.orderNo = '';
            this.searchForm.unionId = '';
            this.searchForm.username = '';
            this.searchForm.type = '';
            this.searchForm.createdDate = '';
            this.searchForm.state = '';
            this.cutCreatedDate = '';
            this.getList();
        },
        //获取数据
        getList() {
            this.evaluateLoad = true;
            if (this.searchForm.createdDate.length > 0) {
                this.cutCreatedDate = (this.searchForm.createdDate[0] + ',' + this.searchForm.createdDate[1])
            }
            this.$ajax.get(evaluateGet,{
                orderNo: this.searchForm.orderNo,
                unionId: this.searchForm.unionId,
                username:this.searchForm.username,
                type: this.searchForm.type,
                state: this.searchForm.state,
                createdDate: this.cutCreatedDate,
                pageSize: this.pageSize,
                pageNumber: this.currentPage
            }).then((res) => {
                this.evaluateLoad = false;
                if (res.status === 200) {// 成功了
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                }
            }, (err) => {
                console.log(err);
            })
        },
        //详情
        detailsClick(row) {
            let id = window.btoa(row.id);
            this.$router.push({
                path: '/evaluateDetail',
                query: {id: id}
            });
            // this.$ajax.get(agreementsSeach(row.orderItem.id)).then((res) => {
            //     if (res.status === 200) {// 成功了
            //         // window.location.href = this.tableDataLoc + res.data.content.location;//在本页面打开
            //         window.open(this.tableDataLoc + res.data.content.location, "_blank", '');//在新页面打开
            //     }
            // }, (err) => {
            //     console.log(err);
            // })
        },
        //删除
        delClick(row){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax.post(evaluateDelete(row.id),{
                }).then((res) => {
                    if (res.status === 200) {// 成功了
                        this.getList();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                }, (err) => {
                    console.log(err);
                })

            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });

        },
    },
    // 数据观察监听
    watch: {
        currentPage(newData,oldData){
            this.getList()
        },
        pageSize(newData,oldData){
            this.getList()
        },
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        this.getList();
    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
